import { SortType } from '@/models/SortType';
import { SuiviFacture } from '@/models/SuiviFacture';

export interface SuiviFacturesAvantEcheanceState {
    facturesAvantEcheance: SuiviFacture[];

    page: number;
    nbOfPages: number;
    count: number;

    sort?: {
        sortData: string;
        sortType: SortType;
    };
    scroll: number;
    isLoading: boolean;
    error?: Error;
    success: boolean;
}

export const initialState: SuiviFacturesAvantEcheanceState = {
    facturesAvantEcheance: [],

    page: 0,
    nbOfPages: 0,
    count: 0,

    scroll: 0,
    isLoading: false,
    success: false,
};

export const state: SuiviFacturesAvantEcheanceState = {
    ...initialState,
};
